import { defineComponent as _defineComponent } from 'vue';
import { computed } from 'vue';
import ApartmentNumberOutput from './ApartmentNumberOutput.vue';
import FloorOutput from './FloorOutput.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'ApartmentPositionOutput',
  props: {
    input: null,
    floorType: {
      default: 'long'
    },
    numberType: {
      default: null
    },
    delimiterSymbol: {
      default: undefined
    },
    empty: {
      default: 'Неизвестно'
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var floor = computed(function () {
      var _props$input;
      return (_props$input = props.input) === null || _props$input === void 0 || (_props$input = _props$input.floor) === null || _props$input === void 0 ? void 0 : _props$input.number;
    });
    var number = computed(function () {
      var _props$input2;
      return (_props$input2 = props.input) === null || _props$input2 === void 0 ? void 0 : _props$input2.number;
    });
    var hasFloor = computed(function () {
      return Boolean(floor.value);
    });
    var hasNumber = computed(function () {
      return Boolean(number.value);
    });
    var hasDelimiter = computed(function () {
      return hasFloor.value && hasNumber.value && props.delimiterSymbol;
    });
    var isEmpty = computed(function () {
      return !hasFloor.value && !hasNumber.value;
    });
    return {
      __sfc: true,
      props: props,
      floor: floor,
      number: number,
      hasFloor: hasFloor,
      hasNumber: hasNumber,
      hasDelimiter: hasDelimiter,
      isEmpty: isEmpty,
      ApartmentNumberOutput: ApartmentNumberOutput,
      FloorOutput: FloorOutput
    };
  }
});